import React from 'react';
import KanbanCard from '../../KanbanView/components/KanbanCard';

export function NeuralFloatingCard({
  model,
  wrapRef,
  nestedSprints,
  onGoToDependencyInGraph,
  cardDisplaySettings,
}) {
  if (!model) return null;
  const { kp, task } = model;
  const closeTagMenu = () => {
    window.dispatchEvent(new CustomEvent('closeTableDropdowns'));
  };
  const afterTagChange = (fn) => (...args) => {
    closeTagMenu();
    fn?.(...args);
  };

  return (
    <div
      ref={wrapRef}
      className="neural-view__floating-card-wrap"
      onPointerDown={(e) => e.stopPropagation()}
      role="dialog"
      aria-label="Selected mission"
    >
      <div className="neural-view__floating-card-frost-clip" aria-hidden="true">
        <canvas className="neural-view__floating-card-frost" />
      </div>
      <KanbanCard
        task={task}
        category={model.currentCategory}
        allCategories={kp.categories || []}
        allTags={kp.allTags?.length ? kp.allTags : kp.categories || []}
        allTasks={kp.tasks}
        statuses={kp.statuses}
        nestedSprint={model.nestedSprint}
        nestedSprints={kp.nestedSprints || nestedSprints}
        allSprints={kp.allSprints || []}
        isBlocked={model.isBlocked}
        lockState={model.lockState}
        cardDisplaySettings={cardDisplaySettings ?? kp.cardDisplaySettings}
        isTemplate={kp.isTemplate}
        onGoToDependency={onGoToDependencyInGraph}
        onSubmitDeliverable={kp.onSubmitDeliverable}
        onEditDeliverables={kp.onEditDeliverables}
        onClearDeliverable={kp.onClearDeliverable}
        onRename={kp.onRename}
        onIconChange={kp.onIconChange}
        onStatusChange={kp.onStatusChange}
        onAddTag={afterTagChange(kp.onAddTag || kp.onCategoryChange)}
        onRemoveTag={afterTagChange(kp.onRemoveTag)}
        onSetPrimaryTag={afterTagChange(kp.onSetPrimaryTag)}
        onRenameTag={kp.onRenameTag || kp.onRenameCategory}
        onDeleteTag={kp.onDeleteTag || kp.onDeleteCategory}
        onOpenDetails={kp.onOpenDetails}
        onOpenAttachments={kp.onOpenAttachments}
        onOpenNestedSprint={kp.onOpenNestedSprint}
        onRemoveNestedSprint={kp.onRemoveNestedSprint}
        onDueDateChange={kp.onDueDateChange}
        onRemindersChange={kp.onRemindersChange}
        onEstimatedDurationMinutesChange={kp.onEstimatedDurationMinutesChange}
        onCreatedAtChange={kp.onCreatedAtChange}
        onStartedAtChange={kp.onStartedAtChange}
        onCompletedAtChange={kp.onCompletedAtChange}
        onUpdatedAtChange={kp.onUpdatedAtChange}
        onPriorityChange={kp.onPriorityChange}
        onDifficultyChange={kp.onDifficultyChange}
        onCustomFieldValueChange={kp.onCustomFieldValueChange}
        customFields={kp.customFields}
        onSetStatusAutoSync={kp.onSetStatusAutoSync}
        onArchiveTask={kp.onArchiveTask}
        onUnarchiveTask={kp.onUnarchiveTask}
        onDependencyChange={kp.onDependencyChange}
        onDecisionAnswerChange={kp.onDecisionAnswerChange}
        onDecisionOptionsChange={kp.onDecisionOptionsChange}
        onAddStatus={kp.onAddStatus}
        onDeleteStatus={kp.onDeleteStatus}
        onRenameStatus={kp.onRenameStatus}
        onDeleteTask={kp.onDeleteTask}
        onCreateParallelMission={kp.onCreateParallelMission}
        onInsertMissionBefore={kp.onInsertMissionBefore}
        currentView={kp.currentView}
        customViews={kp.customViews}
        activeCustomViewId={kp.activeCustomViewId}
        onViewChange={kp.onViewChange}
        onSelectCustomView={kp.onSelectCustomView}
        onGoToTaskInView={kp.onGoToTaskInView}
        onNavigateToParentMission={(payload) => kp.onNavigateToParent?.(payload)}
      />
    </div>
  );
}
